module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/2023_designexpo_logo-ba7035d369423631b07680a3d8ecd05b.svg&quot;;"